module.exports = __webpack_public_path__ + "img/growing.7e6143ae.png";